export default "__VITE_ASSET__BD1u94ql__"